<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col lg="12">
        <div class="card ">
          <div class="card-body">
            <div class="card-title heading-color">
              <mdb-icon icon="filter" size="xs" class="icon-margin" />Regions
              Filter
            </div>
            <DtMultiSelect
              :items="regions"
              :size="1000"
              @onItemCheck="updateRegionsFilter($event)"
              @onSelectAll="updateRegionsFilter($event)"
              @onUnselectAll="unselectAll('regions')"
            ></DtMultiSelect>
          </div>
        </div>
      </mdb-col>
    </mdb-row>
    <hr />
    <mdb-row>
      <mdb-col lg="12">
        <div class="card">
          <div class="card-body">
            <div class="card-title heading-color">
              <mdb-icon icon="filter" size="xs" class="icon-margin" />Services
              Filter
            </div>
            <DtMultiSelect
              :items="services"
              :size="1000"
              @onItemCheck="updateservicesFilter($event)"
              @onSelectAll="updateservicesFilter($event)"
              @onUnselectAll="unselectAll('services')"
            ></DtMultiSelect>
          </div>
        </div>
      </mdb-col>
    </mdb-row>
    <hr />
    <mdb-row>
      <mdb-col lg="12">
        <div class="card ">
          <div class="card-body">
            <div class="card-title heading-color">
              <mdb-icon icon="filter" size="xs" class="icon-margin" />Countries
              Filter
            </div>
            <DtMultiSelect
              :items="countries"
              :size="1000"
              @onItemCheck="updateCountriesFilter($event)"
              @onSelectAll="updateCountriesFilter($event)"
              @onUnselectAll="unselectAll('countries')"
            ></DtMultiSelect>
          </div>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import DtMultiSelect from "./DtMultiSelect";
import {
  getCountries,
  getServices,
  getRegions
} from "../common/dataSourceIntegrationService.js";
import { unselectAll, applyFilter } from "../common/utilities/mapController.js";
import { sortWithName } from "../common/utilities/helpers";
export default {
  name: "Filters",
  components: {
    DtMultiSelect
  },
  data() {
    return {
      countries: [],
      services: [],
      regions: [],
      mapFilters: this.$store.getters.mapFilters
    };
  },
  created() {
    let unsortedCountries = this.addCheck(
      "countries",
      "iso_code",
      getCountries()
    );
    this.countries = sortWithName(unsortedCountries);
    let unsortedServices = this.addCheck("services", "name", getServices());
    this.services = sortWithName(unsortedServices);
    let unsortedRegions = this.addCheck("regions", "name", getRegions());
    this.regions = sortWithName(unsortedRegions);
  },
  methods: {
    // add check = true for being the default status of the filter item check box
    addCheck(filterName, key, items) {
      let newItems = items.map(item => {
        let check = true;
        if (
          this.mapFilters[filterName].length != 0 &&
          !this.mapFilters[filterName].includes(item[key])
        ) {
          check = false;
        }

        return Object.assign({}, item, {
          check: check
        });
      });
      return newItems;
    },
    updateCountriesFilter(targetItems) {
      let targetIsoCodes = [];
      this.countries
        .filter(country => {
          return targetItems.includes(country["name"]);
        })
        .forEach(country => {
          targetIsoCodes.push(country["iso_code"]);
        });
      this.mapFilters.countries = targetIsoCodes;
      this.applyFilters();
    },
    updateservicesFilter(targetItems) {
      this.mapFilters.services = targetItems;
      this.applyFilters();
    },
    updateRegionsFilter(targetItems) {
      this.mapFilters.regions = targetItems;
      this.applyFilters();
    },
    applyFilters() {
      applyFilter(this.mapFilters);
      this.$emit("changed");
    },
    unselectAll(filterName) {
      this.mapFilters[filterName] = [];
      unselectAll();
      this.$emit("changed");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.icon-margin {
  margin-right: 5px;
}
.card {
  box-shadow: none;
  .card-body {
    padding: 0;
  }
}
.card-title.heading-color {
  text-align: left;
  font-size: 1.3rem;
  font-weight: 300;
  margin-bottom: 1rem;
  i {
    display: none;
  }
}
</style>
